// Which countries use Loqate (address autocomplete + verification) instead of
// Google is data-driven: addressProvider in the backend country registry
// (config_lookup rows `country_config:<ISO2>`). The backend is the source of
// truth for which provider actually gets called; this only controls which
// fields render locally (address-search input, free-text state, etc).
import {getRegistryCountry} from './country-registry'

export const isLoqateCountry = countryCode =>
  getRegistryCountry(countryCode)?.addressProvider === 'loqate'
